<template>
  <div>
    <span v-if="showHeading">Please Share</span>
    <social-sharing :url="currentUrl"
                    :title="socialTitle"
                    :description="socialTitle"
                    :quote="socialQuote"
                    hashtags="NationalParkCity"
                    twitter-user="NatParkCityFdn"
                    inline-template>
      <div class="d-flex justify-content-around justify-content-lg-start social-icon">
        <network network="twitter" class="network">
          <v-icon scale="1.5"  name="brands/twitter" v-b-tooltip.hover title="Twitter"></v-icon>
        </network>
        <network network="facebook" class="network">
          <v-icon scale="1.5"  name="brands/facebook-square" v-b-tooltip.hover title="Facebook"></v-icon>
        </network>
        <network network="whatsapp" class="network">
          <v-icon scale="1.5"  name="brands/whatsapp" v-b-tooltip.hover title="Whatsapp"></v-icon>
        </network>
        <network network="email" class="network">
          <v-icon scale="1.5"  name="envelope" v-b-tooltip.hover title="Email"></v-icon>
        </network>
        <network network="reddit" class="network">
          <v-icon scale="1.5"  name="brands/reddit" v-b-tooltip.hover title="Reddit"></v-icon>
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  name: 'SocialShare',
  props: {
    socialTitle: {
      type: String,
      default: 'I\'ve signed the National Park City Universal Charter. Why not sign too?',
    },
    socialQuote: {
      type: String,
      default: 'National Park City Universal Charter',
    },
    currentUrl: {
      type: String,
      default: 'https://www.nationalparkcity.org/charter'
    },
    showHeading: {
      type: Boolean,
      default: true,
    }
  }
};
</script>

<style scoped>
.social-icon {
  cursor: pointer !important;
}
</style>
<style>
  .network {
    padding-right: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/SocialShare.vue